export default __webpack_public_path__ + "static/media/credit-note.573669b9.svg";